// extracted by mini-css-extract-plugin
export default {"viewwrapper":"RegistroDocumentoView_viewwrapper__zvXuN"};